'use client'
import heyaFeaturedData from '@/src/constants/hotels/heyaFeaturedDestinations.json'
import heyaTopHotelsData from '@/src/constants/hotels/heyaTopHotels.json'
import featuredData from '@/src/constants/hotels/homeFeaturedDestinations.json'
import topHotelsData from '@/src/constants/hotels/homeTopHotels.json'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'
import HotelShowcase, { FeaturedDestination, TopHotel } from './hotelShowcase'

// Logic layer: resolves the localized featured-destination slides + Top Hotels list
// (ported from me-flyin's landing-page carousel and staticTopHotels).
const HotelShowcaseWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'
    // Heya lists Saudi hotels only; every other host keeps the default lists.
    const isHeya = useIsHeya()

    const destinations = useMemo<FeaturedDestination[]>(
        () =>
            (isHeya ? heyaFeaturedData : featuredData).destinations.map(dest => ({
                id: dest.id,
                name: isArabic ? dest.name_ar || dest.name_en : dest.name_en,
                city: isArabic ? dest.city_ar || dest.city_en : dest.city_en,
                highlights: isArabic ? dest.highlights_ar || dest.highlights_en : dest.highlights_en,
                imageUrl: dest.imageUrl,
                href: isArabic ? dest.href_ar || dest.href_en : dest.href_en
            })),
        [isArabic, isHeya]
    )

    const topHotels = useMemo<TopHotel[]>(
        () =>
            (isHeya ? heyaTopHotelsData : topHotelsData).hotels.map(hotel => ({
                id: hotel.id,
                name: isArabic ? hotel.name_ar || hotel.name_en : hotel.name_en,
                location: isArabic ? hotel.location_ar || hotel.location_en : hotel.location_en,
                href: isArabic ? hotel.href_ar || hotel.href_en : hotel.href_en
            })),
        [isArabic, isHeya]
    )

    if (destinations.length === 0) return null

    return (
        <HotelShowcase
            destinations={destinations}
            topHotels={topHotels}
            topHotelsTitle={t('topHotels')}
            quickBookLabel={t('quickBook')}
        />
    )
}

export { HotelShowcaseWrapper }
export default HotelShowcaseWrapper
